import MissionAchievedModal from './MissionAchievedModal';
import SubheaderNavItem from './SubheaderNavItem';
import DesktopSubheader from './DesktopSubheader';
import BasicNumberLine from './BasicNumberLine';
import BasicLineGauge from './BasicLineGauge';
import NoHeaderLayout from './NoHeaderLayout';
import ModalContainer from './ModalContainer';
import LoadingBounce from './LoadingBounce';
import DesktopHeader from './DesktopHeader';
import BasicModal from './BasicModal';
import MainLayout from './MainLayout';
import AppHeader from './AppHeader';
import BasicCard from './BasicCard';
import LineGauge from './LineGauge';
import SubHeader from './SubHeader';
import SubHeaderTab from './SubHeaderTab';
import LeftImageCard from './LeftImageCard';
import ImageCard from './ImageCard';
import TextCard from './TextCard';
import VideoCard from './VideoCard';
import Lvideo from './Lvideo';
import Layout from './Layout';
import Card from './Card';
import NavigationBar from './NavigationBar';
import ProgressBar from './ProgressBar';
import ToggleSwitch from './ToggleSwitch';
import CourseCard from './CourseCard';
import CustomModal from './CustomModal';
import ReportContentModal from './ReportContentModal';
import Radio from './Radio';
import EmptyContent from './EmptyContent';
import PrimeSnackBar from './PrimeSnackBar';
import LicenceModal from './LicenceModal';

export const components = {
  MissionAchievedModal,
  SubheaderNavItem,
  DesktopSubheader,
  BasicNumberLine,
  BasicLineGauge,
  NoHeaderLayout,
  ModalContainer,
  LoadingBounce,
  DesktopHeader,
  BasicModal,
  MainLayout,
  AppHeader,
  BasicCard,
  LineGauge,
  SubHeader,
  SubHeaderTab,
  LeftImageCard,
  ImageCard,
  TextCard,
  VideoCard,
  Lvideo,
  Layout,
  Card,
  NavigationBar,
  ProgressBar,
  ToggleSwitch,
  CourseCard,
  CustomModal,
  ReportContentModal,
  Radio,
  EmptyContent,
  PrimeSnackBar,
  LicenceModal,
};

export default function install(Vue) {
  Object.keys(components).forEach((name) => {
    Vue.component(name, components[name]);
  });
}



// WEBPACK FOOTER //
// ./src/components/index.js